var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1935_11218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49995 14.25V10.5H10.5V14.25C10.5 14.6625 10.8375 15 11.25 15H13.5C13.9125 15 14.25 14.6625 14.25 14.25V9.00004H15.525C15.87 9.00004 16.035 8.57254 15.7725 8.34754L9.50245 2.70004C9.21745 2.44504 8.78245 2.44504 8.49745 2.70004L2.22745 8.34754C1.97245 8.57254 2.12995 9.00004 2.47495 9.00004H3.74995V14.25C3.74995 14.6625 4.08745 15 4.49995 15H6.74995C7.16245 15 7.49995 14.6625 7.49995 14.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1935_11218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.8ab165fcc05c3ef47131d88021b22ed7.svg";
export { ForwardRef as ReactComponent };